import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../util/Axios';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { grey } from '@mui/material/colors';
import { PasswordResetStepper } from './PasswordResetStepper';
import { PublicHeader } from '../../components/PublicHeader';
import { useTranslation } from 'react-i18next';

export function BeginPasswordReset() {
  const { i18n } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();
  const [tokenVerified, setTokenVerified] = useState(false);

  useEffect(() => {
    axios
      .get(`passwordResetTokens/${params.token}`)
      .then((resp) => {
        i18n.changeLanguage(resp.data.country === 'BG' ? 'bg' : 'en');
        setTokenVerified(true);
        dispatch({ type: actions.SET_PASSWORD_RESET_TOKEN, payload: params.token });
      })
      .catch((error) => {
        setTokenVerified(true);
        dispatch({ type: actions.INVALID_PASSWORD_RESET_TOKEN });
      });
  }, [dispatch, params.token, i18n]);

  return (
    <>
      <PublicHeader />
      <Box
        bgcolor="background.default"
        sx={{
          backgroundColor: grey[100],
          backgroundPosition: 'center',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {tokenVerified ? <PasswordResetStepper /> : ''}
      </Box>
    </>
  );
}
